import React from 'react';
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Strategic Planning",
    description:
      "Formulate a comprehensive strategy to outline the cross-platform approach, frameworks, and tools for your project.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Unified Coding",
    description:
      "Implement a single codebase, ensuring compatibility across diverse platforms and optimizing development efficiency.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Iterative Development",
    description:
      "Build, test, and iterate functionalities based on continuous feedback, guaranteeing an optimal user experience.",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Quality Assurance",
    description:
      "Conduct rigorous testing across various devices, ensuring a bug-free and seamless user experience.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Deployment Excellence",
    description:
      "Execute a flawless launch on iOS, Android, and other platforms, following strict app store guidelines.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Post-Launch Support",
    description:
      "Provide ongoing monitoring, updates, and support to address post-launch issues and enhance features for sustained success",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 tekrevol_gray_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
            Our Cross-Platform App Development <span>Workflow</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
            Discover innovation in every step with our tailored cross-platform mobile app development services   </p>
            <p>Our methodology is intricately designed to tailor solutions that perfectly match your distinct requirements and goals. </p>
            <p>As a top-rated cross platform app development company, we guarantee unparalleled success of your app.</p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
